var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkAreaMeasurement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 2.38281L20.1213 5.82669V23.15H3.90629L3.90625 2.38281Z",
    fill: "#EFF258",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 1.0216
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00391,
    y: 10.4658,
    width: 22.2045,
    height: 7.61246,
    fill: "url(#paint0_linear_2931_41124)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.346554 9.94957C0.605982 9.84109 0.864561 9.63791 1.12399 9.63791C8.37438 9.6207 15.6248 9.6207 22.8743 9.63791C23.1338 9.63791 23.3932 9.84109 23.6526 9.94957V18.0423C23.4034 18.1396 23.1542 18.3204 22.9041 18.3212C15.6486 18.3367 8.3931 18.3324 1.1376 18.3376C0.827135 18.3376 0.554097 18.2963 0.345703 18.0423C0.346554 15.345 0.346554 12.6477 0.346554 9.94957ZM22.6855 10.628H1.31282V17.3467H2.40072V15.401H3.34827V17.3492H4.43022V13.7609H5.37862V17.3527H6.45972V15.3941H7.40812V17.3561H8.50452V13.7643H9.43847V17.3432H10.5179V15.3992H11.439V17.351H12.5193V13.7609H13.4694V17.3441H14.5879V15.3958H15.5108V17.3535H16.5919V13.7583H17.542V17.3553H18.6384V15.3923H19.5843V17.3467H20.679V13.7652H21.6257V17.3535H22.6863V10.628H22.6855Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 4.51855,
    width: 3.24155,
    height: 3.24155,
    rx: 1.0216,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.28516,
    y: 0.766602,
    width: 3.24155,
    height: 3.24155,
    rx: 1.0216,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.28516,
    y: 21.5342,
    width: 3.24155,
    height: 3.24155,
    rx: 1.0216,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 21.5342,
    width: 3.24155,
    height: 3.24155,
    rx: 1.0216,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2931_41124",
    x1: 12.1061,
    y1: 10.4658,
    x2: 12.1061,
    y2: 18.0783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA6B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34BC93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkAreaMeasurement);
export default __webpack_public_path__ + "static/media/DarkAreaMeasurement.89b29aa8b3a3c4e627ea5941c99c4213.svg";
export { ForwardRef as ReactComponent };